import React from 'react';
import { dotStyle } from '@fabric-ui/theme';
import { Box } from '@mui/material';

interface ColorItemProps {
  item: string;
  isActive?: boolean;
  onClick?: () => void;
  size?: number;
  ref?: React.ForwardedRef<HTMLInputElement>;
}

export const ColorItem = ({ item: color, onClick, isActive = false, size = 20, ref }: ColorItemProps) => (
  <Box
    sx={{
      ...(onClick && { p: '2px' }),
      borderRadius: '50%',
      border: theme => `2px solid ${isActive ? theme.palette.colors.neutrals[600] : 'transparent'}`,
      transition: theme =>
        theme.transitions.create('border-color', {
          duration: theme.transitions.duration.shortest,
        }),
    }}>
    <Box
      ref={ref}
      sx={{
        ...dotStyle(color, size),
        ...(onClick && { cursor: 'pointer' }),
        outline: `2px solid ${isActive ? undefined : 'var(--color-surface-base-primary)'}`,
      }}
      onClick={onClick}
    />
  </Box>
);
